import { wardServices } from "../../Services/WardServices/ward.services";


const wardListing = async (hospitalId, searchData) => {
    let search = searchData ?searchData : ''
    let response = await wardServices.wardListing(hospitalId, search);
    if (response && response.status) {
        return response;
    } else {
        return null;
    }
};


const wardCreate = async () => {
    let post = {
        "title": "Child Special",
        "ward_number": "13",
        "hospital_id": ["10"]
    }
    let response = await wardServices.wardCreate(post);
    if (response && response.status) {
        return response;
    } else {
        return null;
    }
};


const wardDetail = async (id) => {
    let response = await wardServices.wardDetail(id);
    if (response && response.status) {
        return response;
    } else {
        return null;
    }
};


const wardUpdate = async (id) => {
    let response = await wardServices.wardUpdate(id);
    if (response && response.status) {
        return response;
    } else {
        return null;
    }
};


const wardDelete = async (id) => {
    let response = await wardServices.wardDelete(id);
    if (response && response.status) {
        return response;
    } else {
        return null;
    }
};


const wardController = {
    wardListing,
    wardCreate,
    wardDetail,
    wardUpdate,
    wardDelete,
};

export default wardController;
